export default __webpack_public_path__ + "static/media/empty-checkbox.6c7084c9.svg";